<nav class="navbar navbar-default">
    <div class="navbar-container">
        <div class="navbar-logo" (click)="navigateToHome()">
            <img src="assets/img/pay10logo.png" alt="Pay10 Logo" class="logo-img">
        </div>
        <div class="navbar-menu" [class.active]="isMobileMenuOpen">
            <div class="segmented-control"> 
                <a *ngIf="isLoggedIn()" class="nav-link clickable" 
                   [class.active]="activeTab === 'home'"
                   (click)="setActiveTab('home')">Home</a>
                <a class="nav-link clickable" 
                   [class.active]="activeTab === 'integration'"
                   (click)="setActiveTab('integration')">Integration Guide</a>
                <a class="nav-link clickable" 
                   [class.active]="activeTab === 'api'"
                   (click)="setActiveTab('api')">API Explorer</a>
            </div>
            <button class="btn-sign-in mobile-only" *ngIf="!isLoggedIn()" (click)="navigateToLogin()">Sign In</button>
        </div>
        <div class="navbar-actions" *ngIf="!isLoggedIn()">
            <button class="btn-sign-in" (click)="navigateToLogin()">Sign In</button>
        </div>
        <button class="navbar-toggle-mobile" (click)="toggleMobileMenu()" (keydown.enter)="toggleMobileMenu()" (keydown.space)="toggleMobileMenu()" tabindex="0" aria-label="Toggle mobile menu">
            <span class="bar"></span>
            <span class="bar"></span>
            <span class="bar"></span>
        </button>
    </div>
</nav>
